<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'Usa',
  }
</script>

<style scoped>

</style>
